import React from 'react'
import { IStore } from '../../../store'
import { connect } from 'react-redux'
import { LOGIN, LOGIN_ERROR } from '../../../store/user/constants'
import theme from '../../../theme'
import API from '../../../tools/fetch'
import { AxiosResponse } from 'axios'
import Form, { IFormObject, IFormValue } from '../../../components/Form'
import { Link } from 'react-router-dom'
import i18n from '../../../tools/i18n'
import { Mail, UserCheck } from 'react-feather'
import { IAdminCohortObject } from '../../../store/admin/reducer'
import { ADMINCOHORTS_EDITSUCCESS, ADMINCOHORTS_FETCH } from '../../../store/admin/constants'

const inputs: IFormObject[] = [
  {
    name: 'label',
    title: '::Label',
    type: 'text',
    half: false,
    validation: { presence: { allowEmpty: false, message: 'NONE' } },
  },
  {
    name: 'companyType',
    title: '::Type',
    type: 'text',
    half: false,
    validation: { presence: { allowEmpty: false, message: 'NONE' } },
  },
  {
    name: 'visioLink',
    title: '::Lien visio',
    type: 'text',
    half: false,
    validation: { presence: { allowEmpty: false, message: 'NONE' } },
  },
  {
    name: 'startDate',
    title: '::Date de début',
    type: 'date',
    half: false,
    validation: { presence: { allowEmpty: false, message: 'NONE' } },
  },
  {
    name: 'endAccesDate',
    title: `::Date de fin d'accès`,
    type: 'date',
    half: false,
    validation: { presence: { allowEmpty: false, message: 'NONE' } },
  },
  {
    name: 'externTracker',
    title: '::Lien suivi Teachup',
    type: 'text',
    half: false,
    validation: { presence: { allowEmpty: false, message: 'NONE' } },
  },
  {
    name: 'subject',
    title: '::Sujet',
    type: 'subjectSelector',
    half: false,
    validation: { presence: { allowEmpty: false, message: 'NONE' } },
  },
  {
    name: 'scorm',
    title: '::Scorm (Ne spécifier que pour un changement)',
    type: 'zipFile',
    half: false,
    validation: { presence: { allowEmpty: false, message: 'NONE' } },
  },
  {
    name: 'forPartenaire',
    title: '::Pour les partenaires',
    type: 'boolean',
    half: false,
    validation: { presence: { allowEmpty: true, message: 'NONE' } },
  },
]

interface IProps {
  dispatch: (object: { type: string; payload: any }) => void
  goToCohort: (cohortId: number) => void
}

interface IState {
  requesting: boolean
  errored: boolean
  step: '1' | '2'
  success: boolean
  dv: IFormValue[]
}
class AddForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    let dv: IFormValue[] = []

    this.state = {
      requesting: false,
      errored: false,
      step: '1',
      success: false,
      dv: dv,
    }
  }

  public render(): JSX.Element | null {
    return (
      <div style={{ maxWidth: 600 }}>
        <div className="ahome__title">Créer une cohorte</div>
        <Form
          forms={inputs}
          defaultValues={this.state.dv}
          buttonText={'Enregistrer'}
          onValidSubmit={this.onRequest}
          loading={this.state.requesting}
          mainError={this.state.errored}
          placeholder={true}
          label={true}
          mainErrorText={'Impossible de se connecter au serveur.'}
          key={'form1editcohort'}
          //injectedErrors={this.state.injectedErrors}
        />
      </div>
    )
  }
  private onRequest = (values: { [key: string]: any }) => {
    this.setState({ requesting: true, errored: false }, async () => {
      try {
        const formData = new FormData()
        Object.keys(values).forEach((key) => {
          if (key === 'subject') {
            console.log('eeeeoghriuzhrgiuzhgriuz', values[key]['id'])
            formData.append(key, values[key]['id'])
          } else {
            formData.append(key, values[key])
          }
        })

        const request: AxiosResponse = await API.post('/admin/cohorts/add', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        this.setState({ requesting: false, errored: false }, () => this.props.goToCohort(request.data.cohortId))
      } catch (error) {
        this.setState({ requesting: false, errored: true })
      }
    })
  }

  onChangeInput = (name: string, value: string) => {
    //@ts-ignore
    this.setState({ [name]: value })
  }
}

export default connect((store: IStore) => ({
  loading: store.user.isRequesting,
  error: store.user.loginError,
}))(AddForm)
